const translations = {
  en: {
    // Common
    appName: 'SchoolBus',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    create: 'Create',
    update: 'Update',
    search: 'Search...',
    results: '{n} result(s)',
    noData: 'No data found.',
    backToDashboard: '← Back to Dashboard',
    logout: 'Logout',
    actions: 'Actions',
    prev: 'Prev',
    next: 'Next',

    // Auth
    loginTitle: 'Login',
    email: 'Email',
    password: 'Password',
    loginButton: 'Login',
    loginError: 'Invalid credentials.',
    welcome: 'Welcome, {name}',

    // Admin Dashboard
    adminDashboard: 'Admin Dashboard',
    users: 'Users',
    buses: 'Buses',
    routes: 'Routes',
    students: 'Students',
    manageUsers: 'Manage Users',
    manageBuses: 'Manage Buses',
    manageRoutes: 'Manage Routes',
    manageStudents: 'Manage Students',
    tripHistory: 'Trip History',
    liveNotifications: 'Live Notifications',
    listeningEvents: 'Listening for real-time events from drivers and parents...',

    // Users Manager
    name: 'Name',
    phone: 'Phone',
    role: 'Role',
    newPassword: 'New password (leave blank)',

    // Buses Manager
    busNumber: 'Bus #',
    licensePlate: 'License Plate',
    capacity: 'Capacity',
    status: 'Status',
    active: 'Active',
    maintenance: 'Maintenance',
    inactive: 'Inactive',
    busNumberPlaceholder: 'Bus Number',
    licensePlatePlaceholder: 'License Plate',
    capacityPlaceholder: 'Capacity',

    // Routes Manager
    routeName: 'Route Name',
    description: 'Description',
    assignedBus: 'Assigned Bus',
    noBusAssigned: 'No Bus Assigned',
    unassigned: 'Unassigned',
    routeNamePlaceholder: 'Route Name',
    descriptionPlaceholder: 'Description',

    // Students Manager
    firstName: 'First Name',
    lastName: 'Last Name',
    parent: 'Parent',
    address: 'Address',
    selectParent: 'Select Parent',
    noRoute: 'No Route',
    firstNamePlaceholder: 'First Name',
    lastNamePlaceholder: 'Last Name',
    homeAddressPlaceholder: 'Home Address',
    latitudePlaceholder: 'Latitude',
    longitudePlaceholder: 'Longitude',
    photo: 'Photo',
    uploadPhoto: 'Upload Photo',
    removePhoto: 'Remove Photo',
    homeLocations: 'Home Locations',
    addLocation: 'Add Location',
    locationLabel: 'Label (e.g. Home, Grandparents)',
    locationAddress: 'Address',
    primary: 'Primary',
    noLocations: 'No additional locations.',
    manageLocations: 'Manage Locations',
    close: 'Close',

    // Driver Panel
    driverPanel: 'Driver Panel',
    configuration: 'Configuration',
    bus: 'Bus',
    route: 'Route',
    connectToServer: 'Connect to Server',
    connected: 'Connected',
    tripControls: 'Trip Controls',
    status: 'Status',
    onRoute: 'On Route',
    stopped: 'Stopped',
    startTrip: 'Start Trip',
    endTrip: 'End Trip',
    simulation: 'Simulation',
    studentsOnRoute: 'Students on Route ({n})',
    pickedUp: 'PICKED UP',
    droppedOff: 'DROPPED OFF',
    pending: 'Pending',
    pickup: 'Pickup',
    dropoff: 'Dropoff',
    gpsMode: 'GPS Mode',
    realGps: 'Real GPS',
    simulatedGps: 'Simulated',
    realGpsActive: 'Real GPS Active',
    simulatedGpsActive: 'Simulation Active',
    currentLocation: 'Current Location',
    gpsAccuracy: 'Accuracy',
    gpsError: 'GPS error',
    gpsPermissionDenied: 'GPS permission denied. Please enable location access.',
    gpsNotSupported: 'GPS not supported on this device.',
    acquiringGps: 'Acquiring GPS signal...',
    gpsTimeout: 'GPS timeout. Please try again in an open area.',
    screenWakeLock: 'Screen stays on during trip',

    // Parent Dashboard
    parentDashboard: 'Parent Dashboard',
    busTracking: 'Bus Tracking',
    student: 'Student',
    listeningRoute: 'Listening to route',
    busMoving: 'Bus is moving!',
    waitingGps: 'Waiting for GPS coordinates from driver...',
    enableNotifications: 'Enable Notifications',
    notificationsOn: 'Notifications ON',
    pickupDropoffNotifications: 'Pickup / Drop-off Notifications',
    waitingEvents: 'No events yet. Waiting for driver to log pickup or drop-off...',
    pickedUpLabel: 'Picked Up',
    droppedOffLabel: 'Dropped Off',
    routeTrail: 'Route trail: {n} points recorded',

    // Trip History
    tripHistoryTitle: 'Trip History',
    gpsPoints: '{n} GPS points',
    attendanceEvents: '{n} attendance events',
    pickupDropoffEvents: 'Pickup / Drop-off Events',
    noGpsData: 'No GPS data recorded for this trip.',
    selectTrip: 'Select a trip from the list to view its history',
    replayPosition: 'Replay Position',

    // Live Tracking
    liveTracking: 'Live Tracking',
    noActiveTrips: 'No active trips right now',
    activeBuses: 'Active Buses',
    selectBusToTrack: 'Select a bus from the list to track it live',
    totalStudents: 'Total',
    inBus: 'In Bus',
    driver: 'Driver',
    startedAt: 'Started',

    // Notifications
    busUpdated: 'Bus {id} updated position',
    studentPickedUp: '{name} picked up',
    studentDroppedOff: '{name} dropped off',
  },

  fr: {
    // Common
    appName: 'SchoolBus',
    loading: 'Chargement...',
    save: 'Enregistrer',
    cancel: 'Annuler',
    edit: 'Modifier',
    delete: 'Supprimer',
    create: 'Créer',
    update: 'Mettre à jour',
    search: 'Rechercher...',
    results: '{n} résultat(s)',
    noData: 'Aucune donnée trouvée.',
    backToDashboard: '← Retour au tableau de bord',
    logout: 'Déconnexion',
    actions: 'Actions',
    prev: 'Préc',
    next: 'Suiv',

    // Auth
    loginTitle: 'Connexion',
    email: 'Email',
    password: 'Mot de passe',
    loginButton: 'Se connecter',
    loginError: 'Identifiants invalides.',
    welcome: 'Bienvenue, {name}',

    // Admin Dashboard
    adminDashboard: 'Tableau de bord admin',
    users: 'Utilisateurs',
    buses: 'Bus',
    routes: 'Trajets',
    students: 'Élèves',
    manageUsers: 'Gérer les utilisateurs',
    manageBuses: 'Gérer les bus',
    manageRoutes: 'Gérer les trajets',
    manageStudents: 'Gérer les élèves',
    tripHistory: 'Historique des trajets',
    liveNotifications: 'Notifications en temps réel',
    listeningEvents: 'En attente des événements en temps réel des chauffeurs et parents...',

    // Users Manager
    name: 'Nom',
    phone: 'Téléphone',
    role: 'Rôle',
    newPassword: 'Nouveau mot de passe (laisser vide)',

    // Buses Manager
    busNumber: 'N° Bus',
    licensePlate: 'Plaque d\'immatriculation',
    capacity: 'Capacité',
    status: 'Statut',
    active: 'Actif',
    maintenance: 'Maintenance',
    inactive: 'Inactif',
    busNumberPlaceholder: 'Numéro de bus',
    licensePlatePlaceholder: 'Plaque d\'immatriculation',
    capacityPlaceholder: 'Capacité',

    // Routes Manager
    routeName: 'Nom du trajet',
    description: 'Description',
    assignedBus: 'Bus assigné',
    noBusAssigned: 'Aucun bus assigné',
    unassigned: 'Non assigné',
    routeNamePlaceholder: 'Nom du trajet',
    descriptionPlaceholder: 'Description',

    // Students Manager
    firstName: 'Prénom',
    lastName: 'Nom',
    parent: 'Parent',
    address: 'Adresse',
    selectParent: 'Sélectionner un parent',
    noRoute: 'Aucun trajet',
    firstNamePlaceholder: 'Prénom',
    lastNamePlaceholder: 'Nom',
    homeAddressPlaceholder: 'Adresse du domicile',
    latitudePlaceholder: 'Latitude',
    longitudePlaceholder: 'Longitude',
    photo: 'Photo',
    uploadPhoto: 'Télécharger la photo',
    removePhoto: 'Supprimer la photo',
    homeLocations: 'Adresses du domicile',
    addLocation: 'Ajouter une adresse',
    locationLabel: 'Libellé (ex: Maison, Grands-parents)',
    locationAddress: 'Adresse',
    primary: 'Principale',
    noLocations: 'Aucune adresse supplémentaire.',
    manageLocations: 'Gérer les adresses',
    close: 'Fermer',

    // Driver Panel
    driverPanel: 'Panneau chauffeur',
    configuration: 'Configuration',
    bus: 'Bus',
    route: 'Trajet',
    connectToServer: 'Se connecter au serveur',
    connected: 'Connecté',
    tripControls: 'Contrôle du trajet',
    status: 'Statut',
    onRoute: 'En trajet',
    stopped: 'Arrêté',
    startTrip: 'Démarrer le trajet',
    endTrip: 'Terminer le trajet',
    simulation: 'Simulation',
    studentsOnRoute: 'Élèves sur le trajet ({n})',
    pickedUp: 'EMBARQUÉ',
    droppedOff: 'DÉPOSÉ',
    pending: 'En attente',
    pickup: 'Embarquer',
    dropoff: 'Déposer',
    gpsMode: 'Mode GPS',
    realGps: 'GPS réel',
    simulatedGps: 'Simulé',
    realGpsActive: 'GPS réel actif',
    simulatedGpsActive: 'Simulation active',
    currentLocation: 'Position actuelle',
    gpsAccuracy: 'Précision',
    gpsError: 'Erreur GPS',
    gpsPermissionDenied: 'Permission GPS refusée. Veuillez activer l\'accès à la localisation.',
    gpsNotSupported: 'GPS non supporté sur cet appareil.',
    acquiringGps: 'Acquisition du signal GPS...',
    gpsTimeout: 'Délai GPS dépassé. Réessayez en zone ouverte.',
    screenWakeLock: 'L\'écran reste allumé pendant le trajet',

    // Parent Dashboard
    parentDashboard: 'Tableau de bord parent',
    busTracking: 'Suivi du bus',
    student: 'Élève',
    listeningRoute: 'Écoute du trajet',
    busMoving: 'Le bus est en mouvement !',
    waitingGps: 'En attente des coordonnées GPS du chauffeur...',
    enableNotifications: 'Activer les notifications',
    notificationsOn: 'Notifications ACTIVÉES',
    pickupDropoffNotifications: 'Notifications d\'embarquement / dépôt',
    waitingEvents: 'Aucun événement. En attente du chauffeur...',
    pickedUpLabel: 'Embarqué',
    droppedOffLabel: 'Déposé',
    routeTrail: 'Trace : {n} points enregistrés',

    // Trip History
    tripHistoryTitle: 'Historique des trajets',
    gpsPoints: '{n} points GPS',
    attendanceEvents: '{n} événements de présence',
    pickupDropoffEvents: 'Événements d\'embarquement / dépôt',
    noGpsData: 'Aucune donnée GPS enregistrée pour ce trajet.',
    selectTrip: 'Sélectionnez un trajet pour voir son historique',
    replayPosition: 'Position de lecture',

    // Live Tracking
    liveTracking: 'Suivi en direct',
    noActiveTrips: 'Aucun trajet actif en cours',
    activeBuses: 'Bus actifs',
    selectBusToTrack: 'Sélectionnez un bus pour le suivre en direct',
    totalStudents: 'Total',
    inBus: 'Dans le bus',
    driver: 'Chauffeur',
    startedAt: 'Démarré',

    // Notifications
    busUpdated: 'Bus {id} a mis à jour sa position',
    studentPickedUp: '{name} a été embarqué(e)',
    studentDroppedOff: '{name} a été déposé(e)',
  },

  ar: {
    // Common
    appName: 'مدرسي',
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    edit: 'تعديل',
    delete: 'حذف',
    create: 'إنشاء',
    update: 'تحديث',
    search: 'بحث...',
    results: '{n} نتيجة',
    noData: 'لا توجد بيانات.',
    backToDashboard: '← العودة للوحة التحكم',
    logout: 'تسجيل خروج',
    actions: 'إجراءات',
    prev: 'السابق',
    next: 'التالي',

    // Auth
    loginTitle: 'تسجيل الدخول',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    loginButton: 'دخول',
    loginError: 'بيانات اعتماد غير صالحة.',
    welcome: 'مرحبا، {name}',

    // Admin Dashboard
    adminDashboard: 'لوحة تحكم المدير',
    users: 'المستخدمون',
    buses: 'الحافلات',
    routes: 'المسارات',
    students: 'التلاميذ',
    manageUsers: 'إدارة المستخدمين',
    manageBuses: 'إدارة الحافلات',
    manageRoutes: 'إدارة المسارات',
    manageStudents: 'إدارة التلاميذ',
    tripHistory: 'سجل الرحلات',
    liveNotifications: 'إشعارات مباشرة',
    listeningEvents: 'في انتظار الأحداث المباشرة من السائقين والأولياء...',

    // Users Manager
    name: 'الاسم',
    phone: 'الهاتف',
    role: 'الدور',
    newPassword: 'كلمة مرور جديدة (اتركها فارغة)',

    // Buses Manager
    busNumber: 'رقم الحافلة',
    licensePlate: 'رقم اللوحة',
    capacity: 'السعة',
    status: 'الحالة',
    active: 'نشطة',
    maintenance: 'صيانة',
    inactive: 'غير نشطة',
    busNumberPlaceholder: 'رقم الحافلة',
    licensePlatePlaceholder: 'رقم اللوحة',
    capacityPlaceholder: 'السعة',

    // Routes Manager
    routeName: 'اسم المسار',
    description: 'الوصف',
    assignedBus: 'الحافلة المخصصة',
    noBusAssigned: 'لا توجد حافلة مخصصة',
    unassigned: 'غير مخصص',
    routeNamePlaceholder: 'اسم المسار',
    descriptionPlaceholder: 'الوصف',

    // Students Manager
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    parent: 'الولي',
    address: 'العنوان',
    selectParent: 'اختر الولي',
    noRoute: 'لا مسار',
    firstNamePlaceholder: 'الاسم الأول',
    lastNamePlaceholder: 'اسم العائلة',
    homeAddressPlaceholder: 'عنوان المنزل',
    latitudePlaceholder: 'خط العرض',
    longitudePlaceholder: 'خط الطول',
    photo: 'الصورة',
    uploadPhoto: 'رفع الصورة',
    removePhoto: 'إزالة الصورة',
    homeLocations: 'عناوين المنزل',
    addLocation: 'إضافة عنوان',
    locationLabel: 'الاسم (مثال: المنزل، الأجداد)',
    locationAddress: 'العنوان',
    primary: 'الرئيسي',
    noLocations: 'لا توجد عناوين إضافية.',
    manageLocations: 'إدارة العناوين',
    close: 'إغلاق',

    // Driver Panel
    driverPanel: 'لوحة السائق',
    configuration: 'الإعدادات',
    bus: 'الحافلة',
    route: 'المسار',
    connectToServer: 'الاتصال بالخادم',
    connected: 'متصل',
    tripControls: 'تحكم الرحلة',
    status: 'الحالة',
    onRoute: 'في الطريق',
    stopped: 'متوقف',
    startTrip: 'بدء الرحلة',
    endTrip: 'إنهاء الرحلة',
    simulation: 'محاكاة',
    studentsOnRoute: 'التلاميذ في المسار ({n})',
    pickedUp: 'تم الصعود',
    droppedOff: 'تم النزول',
    pending: 'في الانتظار',
    pickup: 'صعود',
    dropoff: 'نزول',
    gpsMode: 'وضع GPS',
    realGps: 'GPS حقيقي',
    simulatedGps: 'محاكاة',
    realGpsActive: 'GPS حقيقي نشط',
    simulatedGpsActive: 'محاكاة نشطة',
    currentLocation: 'الموقع الحالي',
    gpsAccuracy: 'الدقة',
    gpsError: 'خطأ في GPS',
    gpsPermissionDenied: 'تم رفض إذن GPS. يرجى تفعيل الوصول إلى الموقع.',
    gpsNotSupported: 'GPS غير مدعوم على هذا الجهاز.',
    acquiringGps: 'جاري الحصول على إشارة GPS...',
    gpsTimeout: 'انتهت مهلة GPS. يرجى المحاولة مرة أخرى في مكان مفتوح.',
    screenWakeLock: 'الشاشة تبقى مضاءة أثناء الرحلة',

    // Parent Dashboard
    parentDashboard: 'لوحة تحكم الولي',
    busTracking: 'تتبع الحافلة',
    student: 'التلميذ',
    listeningRoute: 'يتابع المسار',
    busMoving: 'الحافلة تتحرك!',
    waitingGps: 'في انتظار إحداثيات GPS من السائق...',
    enableNotifications: 'تفعيل الإشعارات',
    notificationsOn: 'الإشعارات مفعلة',
    pickupDropoffNotifications: 'إشعارات الصعود والنزول',
    waitingEvents: 'لا توجد أحداث بعد. في انتظار السائق...',
    pickedUpLabel: 'تم الصعود',
    droppedOffLabel: 'تم النزول',
    routeTrail: 'المسار: {n} نقطة مسجلة',

    // Trip History
    tripHistoryTitle: 'سجل الرحلات',
    gpsPoints: '{n} نقطة GPS',
    attendanceEvents: '{n} أحداث حضور',
    pickupDropoffEvents: 'أحداث الصعود والنزول',
    noGpsData: 'لا توجد بيانات GPS مسجلة لهذه الرحلة.',
    selectTrip: 'اختر رحلة لعرض سجلها',
    replayPosition: 'موضع التشغيل',

    // Live Tracking
    liveTracking: 'تتبع مباشر',
    noActiveTrips: 'لا توجد رحلات نشطة الآن',
    activeBuses: 'الحافلات النشطة',
    selectBusToTrack: 'اختر حافلة من القائمة لتتبعها مباشرة',
    totalStudents: 'المجموع',
    inBus: 'في الحافلة',
    driver: 'السائق',
    startedAt: 'بدأ',

    // Notifications
    busUpdated: 'الحافلة {id} حدّثت موقعها',
    studentPickedUp: '{name} صعد إلى الحافلة',
    studentDroppedOff: '{name} نزل من الحافلة',
  },
};

export default translations;
